import {Component, inject, Inject, OnInit} from '@angular/core';
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ActiveUserService} from "../../../services/active-user.service";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {SnackbarService} from "../../../services/snackbar.service";
import {IUploadImageToAzure} from "../../../interfaces/IUploadImageToAzure";
import {GameThemeType} from "../../../enum/GameThemeType";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {MatToolbar} from "@angular/material/toolbar";
import {AssetManagementService} from "../../../services/asset-management.service";

@Component({
  selector: 'app-edit-game-image',
  standalone: true,
  imports: [
    DialogBaseComponent,
    FormsModule,
    MatButton,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatLabel,
    MatOption,
    MatSelect,
    MatToolbar,
    ReactiveFormsModule
  ],
  templateUrl: './edit-game-image.component.html',
  styleUrl: './edit-game-image.component.css'
})
export class EditGameImageComponent implements OnInit {

  private activeUserService: ActiveUserService = inject(ActiveUserService);
  private snackBarService: SnackbarService = inject(SnackbarService);
  public assetManagementService: AssetManagementService = inject(AssetManagementService);

  public uiState = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;
  public gameThemeType = GameThemeType;

  constructor(private dialogRef: MatDialogRef<EditGameImageComponent>,
              @Inject(MAT_DIALOG_DATA) public game: IGameQueryResult) {
  }

  ngOnInit() {
    this.assetManagementService.checkForExistingGameLogo(this.game.Subdomain);
  }

  onGameLogoFileSelected(event: any) {
    this.assetManagementService.handleGameLogoSelected(event)
  }

  onThemeTypeChange(valueP: GameThemeType) {
    this.assetManagementService.handleThemeTypeChange(valueP);
  }

  saveGameLogo() {
    if (!this.assetManagementService.gameLogoImage) {
      this.dialogRef.close();
    }

    this.uiState = UIStateEnum.ShowLoading;

    const formData = new FormData();

    if (this.assetManagementService.gameLogoImage) {
      formData.append('file', this.assetManagementService.gameLogoImage, 'game-logo.svg');

      const new_logo_request: IUploadImageToAzure = {
        gameId: this.game.Id,
        image: formData,
        adminId: this.activeUserService.activeUser().Id
      };

      this.assetManagementService.uploadGameImage(new_logo_request).subscribe({
        next: (res: any) => {
          if (res.status == 200) {
            this.uiState = UIStateEnum.ShowData;
            this.snackBarService.openSuccessfulSnackBar('Successfully uploaded Game Logo.');
            this.dialogRef.close();
          }
        },
        error: err => {
          this.uiState = UIStateEnum.ShowData;
          this.snackBarService.openErrorSnackBar('Failed to upload Game Logo.');
        }
      });
    }
  }
}
